import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService }   from '@omnilib/services/data.service';
import { ListService }   from '@omnilib/services/list.service';
import { RouterService } from '@omnipas/services/router.service';
import { AddAddressRequest } from '../models/add-address.model';
import { firstValueFrom, Observable } from 'rxjs';
import { ApiResponse } from '../models/api-response.model';
import { environment } from '@omnienv/omnipas/dev/environment';

@Injectable({
  providedIn: 'root'
})
export class DeliveryAddressService {
  constructor( public data:   DataService
             , public list:   ListService
             , public router: RouterService
             , public http: HttpClient
             ) {
              this.addressObject = new AddAddressRequest();
  }

  found:        boolean = false;
  addresstype:  string  = '';
  addressLine1: string  = '';
  addressLine2: string  = '';
  addressObject: AddAddressRequest;


  async get() {
    if ( this.list.emptyList( this.router.freefields['personfreefields'] ) ) {
      let result = await this.data.callapi ( 'get', 'freefield/person', {} );

      if ( result['result']['code'] && result['result']['code'] == '0' && !this.list.emptyList( result['result']['resultset'] ) ) {
        this.router.freefields['personfreefields'] =  result['result']['resultset'];
        this.found = true;
      }
    } else {
      this.found = true;
    }

    console.log ( this.router.freefields );

    if ( this.found && this.list.getValue( this.router.freefields['personfreefields'], 'freeField05', true ) == 'Ja' ) {
      this.addresstype  = 'deliveryaddress';
      this.addressLine1 = this.list.getValue( this.router.freefields['personfreefields'], 'freeField07', true );
      this.addressLine2 = this.list.getValue( this.router.freefields['personfreefields'], 'freeField08', true );
    } else if( this.list.getValue( this.router.persondata, 'street', true ) != '' ) {
      this.addresstype  = 'systemaddress';
      this.addressLine1 = this.list.getValue( this.router.persondata, 'street', true ) + ' ' + this.list.getValue( this.router.persondata, 'number', true ) + ' ' + this.list.getValue( this.router.persondata, 'suffix', true );
      this.addressLine2 = this.list.getValue( this.router.persondata, 'postalCode', true ) + '  ' + this.list.getValue( this.router.persondata, 'city', true );
    } else {
      this.addresstype  = 'noaddressfound';
      this.addressLine1 = '';
      this.addressLine2 = '';
    }
  }

  async update(street: string, number: string, suffix: string, postalCode: string, city: string, province: string, country: string): Promise<boolean> {
    this.addressObject.street = street;
    this.addressObject.number = number;
    this.addressObject.suffix = suffix;
    this.addressObject.postalCode = postalCode;
    this.addressObject.city = city;
    this.addressObject.province = province;
    this.addressObject.country = country;

    try {
      const result = await firstValueFrom(this.postAddress(this.addressObject));
      return result?.result?.code == "0";
    } catch (e) {
      console.error(e);
      return false;
    }
  }

   postAddress(address: AddAddressRequest): Observable<ApiResponse<undefined>> {
      let httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json', "Authorization": "Bearer " + sessionStorage.getItem('jwt') })
      }
      return this.http.post<ApiResponse<undefined>>(environment.apiurl + "address", address, httpOptions);
    }

  async updateFreeField() {
    // Snapshot the address lines constructed by the caller: get() below
    // overwrites this.addressLine1/2 with the existing freefield/persondata values.
    let addressLine1 = this.addressLine1;
    let addressLine2 = this.addressLine2;

    await this.get();

    let params = { 
      "freeField05" : "Ja",
      "freeField07" : addressLine1,
      "freeField08" : addressLine2
    }

    let result = await this.data.callapi ( this.found ?  'put' : 'post', 'freefield/person', params );

    if ( result['result']['code'] && result['result']['code'] == '0' ) {
      return true;
    } else {
      return false;
    }
  }

}
